export enum DepositProductsColumns {
	id = "Id",
	status = "Status",
	org = "Org",
	name = "Name",
	bank = "Bank",
	createdAt = "Created At",
}

export type AllowedDepositProductsColumns =
	| DepositProductsColumns.id
	| DepositProductsColumns.status
	| DepositProductsColumns.org
	| DepositProductsColumns.name
	| DepositProductsColumns.bank
	| DepositProductsColumns.createdAt
